import {
    InMemoryHeader,
    InMemoryString,
} from "pbas-vue-components";

import {translate2} from "../trans2";

const UsersReportsHeaders = [
    new InMemoryHeader({
        type: new InMemoryString("Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        isIdentifier: true,
        version: 1
    }),
    new InMemoryHeader({
        title: "headers.usersreports.report_type",
        type: new InMemoryString("ReportParameters/ReportType"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new InMemoryHeader({
        title: "globals.plan",
        type: new InMemoryString("Plan/Translations[]/Name", {
            getString:(item)=>translate2(item.Plan, "Name")
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
];
export default UsersReportsHeaders;